import type { PropsWithChildren, ReactNode } from "react";

type NormalLayoutProps = PropsWithChildren<{
  navigation?: ReactNode;
  footer?: ReactNode;
  loginModal?: ReactNode;
}>;

function NormalLayout({ children, navigation, footer, loginModal }: NormalLayoutProps) {
  return (
    <div className="flex min-h-screen flex-col bg-background text-foreground">
      {navigation}
      <main className="flex-1">{children}</main>
      {footer}
      {loginModal}
    </div>
  );
}

export { NormalLayout };
export type { NormalLayoutProps };
